import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 relative">
      <div className="section-divider mb-24 max-w-7xl mx-auto" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="FAQ" title="Everything Indian business owners ask us." center />
        <Accordion type="single" collapsible className="w-full space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass rounded-2xl px-5 border border-white/10"
            >
              <AccordionTrigger className="text-left text-white hover:no-underline hover:text-[#D4AF37] text-base font-medium py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-5 pr-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
